export default __webpack_public_path__ + "static/media/cover.96478ecd.png";